import { getKeys, getValue } from './objprops';

type KeyProviderFn<T> = (_item: T) => string;

export function caseInsensitiveSort<T>(
  key: string | string[] | KeyProviderFn<T>,
) {
  const keys =
    Array.isArray(key) || typeof key === 'string' ? getKeys(key) : [];
  const fn = !keys.length ? (key as KeyProviderFn<T>) : null;

  return (a: T, b: T) => {
    const va = (
      (fn ? fn(a) : getValue<T, string>(a, keys)) || ''
    ).toLowerCase();
    const vb = (
      (fn ? fn(b) : getValue<T, string>(b, keys)) || ''
    ).toLowerCase();
    if (va < vb) {
      return -1;
    } else if (va > vb) {
      return 1;
    }

    return 0;
  };
}
